// extracted by mini-css-extract-plugin
export default {"articleContent":"ArticleContent_articleContent__QxoXb"};